import React, { Component } from 'react';
import { Form, Input, DatePicker } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { InputNumber } from '../../../../components/common/input-number';
import { Dropdown } from '../../../../components/common/dropdown';

export class CarOwner extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAvisCar: false,
            fuel_groups: [],
            supplier_groups: [],
            branches: [],
        }
    }

    onSelectFuelType = data => {
        const { onChangeForm } = this.props;
        onChangeForm('fuel_type_code', data.code);
    }

    onSelectCarResouce = data => {
        const { onChangeForm } = this.props;
        onChangeForm('car_resource', data.code);
        if (data.name === 'AVIS') {
            onChangeForm('owner', 'AVIS');
            this.setState({
                isAvisCar: true,
            });
        } else {
            onChangeForm('owner', '');
            this.setState({
                isAvisCar: false,
            });
        }
    }

    onSelectAreaManagement = data => {
        const { onChangeForm } = this.props;
        onChangeForm('area_management', data.code);
    }

    render() {
        const { isAvisCar, fuel_groups, supplier_groups, branches } = this.state;
        const { editable } = this.props;
        return <>
            <Form.Item
                wrapperCol={15}
                className="alignment"
                name='ensurrance_expiry_date'
                label='Ngày hết hạn bảo hiểm bắt buộc::'
                rules={[
                ]}>
                <DatePicker
                    disabled={!editable}
                    // inputReadOnly
                    dropdownClassName="date-picker-dropdown-top"
                    getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                        return document.body;
                    }} format='DD/MM/YYYY' className="dropdown-full" />
            </Form.Item>
            <Form.Item
                wrapperCol={15}
                name='road_toll_expiry_date'
                className="alignment"
                label='Ngày hết hạn phí đường bộ::'
                rules={[]}
            >
                <DatePicker
                    disabled={!editable}
                    // inputReadOnly
                    dropdownClassName="date-picker-dropdown-top"
                    getPopupContainer={node => {
                        if (node) {
                            return node.parentNode;
                        }
                        return document.body;
                    }} format='DD/MM/YYYY' className="dropdown-full" />
            </Form.Item>
            <Form.Item
                name={'fuel_type_code'}
                label='* Loại nhiên liệu::'
                rules={[
                    {
                        required: true,
                        message: `Vui lòng chọn Loại nhiên liệu!`,
                    }
                ]}>
                <Dropdown
                    disabled={!editable}
                    select={this.onSelectFuelType}
                    className="dropdown-full"
                    title="Chọn loại nhiên liệu"
                    menu={fuel_groups} />
            </Form.Item>
            <Form.Item
                name={'origin'}
                label='* Xuất xứ::'
                rules={[
                    {
                        required: true,
                        message: `Vui lòng nhập Xuất xứ!`,
                    }
                ]}>
                <Input
                    disabled={!editable}
                    placeholder='Xuất xứ' />
            </Form.Item>
            <Form.Item
                name={'car_resource'}
                label='* Nguồn xe::'
                rules={[
                    {
                        required: true,
                        message: `Vui lòng chọn Nguồn xe!`,
                    }
                ]}>
                <Dropdown
                    disabled={!editable}
                    select={this.onSelectCarResouce}
                    className="dropdown-full"
                    title="Chọn nguồn xe"
                    menu={supplier_groups} />
            </Form.Item>
            <Form.Item
                name={'owner'}
                label='* Chủ sở hữu::'
                rules={[
                    {
                        required: true,
                        message: `Vui lòng nhập Chủ sở hữu!`,
                    }
                ]}>
                <Input disabled={isAvisCar || !editable} value={isAvisCar ? 'Avis' : ''} placeholder='Chủ sở hữu' />
            </Form.Item>
            <Form.Item
                name={'area_management'}
                label='* Khu vực quản lý::'
                rules={[
                    {
                        required: true,
                        message: `Vui lòng chọn Khu vực quản lý!`,
                    }
                ]}>
                <Dropdown
                    disabled={!editable}
                    select={this.onSelectAreaManagement}
                    className="dropdown-full"
                    title="Chọn khu vực quản lý"
                    menu={branches} />
            </Form.Item>
        </>
    }
}